import { observer } from 'mobx-react';
import React from 'react';

import FooterCopyright from '../../../footer/FooterCopyright';

export const CheckoutFooter = () => {
  return (
    <footer className="CheckoutFooter">
      <FooterCopyright />
    </footer>
  );
};

export default observer(CheckoutFooter);
